import { IHSCodeData } from '@/models';
import { IHarmonizedSystemService } from './harmonized-system.types';
import { AxiosInstance } from 'axios';

export class HarmonizedSystemService implements IHarmonizedSystemService {
  private endpoint: string;

  constructor(private axios: AxiosInstance) {
    this.endpoint = 'v1/hs-codes/';
  }

  fetchHSCodes(): Promise<IHSCodeData[]> {
    return this.axios
      .get<IHSCodeData[]>(`${this.endpoint}`)
      .then(({ data }) => data);
  }

  fetchHSCode(code: string): Promise<IHSCodeData> {
    return this.axios
      .get<IHSCodeData>(`${this.endpoint}${code}/`)
      .then(({ data }) => data);
  }

  createHSCode(data: IHSCodeData): Promise<IHSCodeData> {
    return this.axios
      .post<IHSCodeData>(`${this.endpoint}`, data)
      .then(({ data }) => data);
  }

  updateHSCode(data: IHSCodeData): Promise<IHSCodeData> {
    return this.axios
      .patch<IHSCodeData>(`${this.endpoint}${data.code}/`, data)
      .then(({ data }) => data);
  }

  deleteHSCode(code: string): Promise<void> {
    return this.axios
      .delete(`${this.endpoint}${code}/`)
      .then(({ data }) => data);
  }

  uploadHSCodes(file: File): Promise<void> {
    const formData = new FormData();
    formData.append('file_upload', file);

    return this.axios
      .post<void>(`${this.endpoint}upload-file/`, formData, {
        headers: {
          'Content-Type': 'multipart/form-data'
        }
      })
      .then(({ data }) => data);
  }
}
